<template>
  <div class="responses-grid" :class="{ 'is-disabled': isDisabled }">
    <div
      v-for="response in responses"
      :key="response.id"
      class="response-card"
      :class="{ 
        'selected': response.isSelected, 
        'auto-selected': response.autoSelected 
      }"
      @click="onResponseClick(response)"
    >
      <div class="response-content">
        <div class="response-text">{{ response.response }}</div>
        <div v-if="response.autoSelected" class="auto-selected-badge">Auto-selected</div>
        <div class="response-actions">
          <button
            v-if="response.imageBase64"
            class="action-btn"
            @click.stop="$emit('show-image', response.imageBase64)"
            title="View Image"
          >
            <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" /></svg>
          </button>
          <button
            v-if="response.information"
            class="action-btn"
            @click.stop="$emit('show-information', response)"
            title="More Information"
          >
            <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponseGrid',
  props: {
    responses: {
      type: Array,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select-response', 'show-image', 'show-information'],
  methods: {
    onResponseClick(response) {
      if (this.isDisabled) {
        return;
      }
      this.$emit('select-response', response);
    },
  },
};
</script>

<style lang="scss" scoped>
.responses-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;

  &.is-disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.response-card {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #D1D5DB;
    background-color: #F3F4F6;
    transform: translateY(-1px);
  }

  &.selected {
    background-color: rgba(1, 59, 130, 0.08);
    border-color: #013B82;

    .response-text {
      color: #013B82;
      font-weight: 600;
    }

    .action-btn {
      color: #013B82;

      &:hover {
        background-color: rgba(1, 59, 130, 0.1);
      }
    }
  }

  &.auto-selected {
    position: relative;

    .auto-selected-badge {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 11px;
      background-color: #047857;
      color: white;
      padding: 2px 6px;
      border-radius: 0 6px 0 6px;
      opacity: 0.9;
    }
  }

  .response-content {
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    position: relative;
  }

  .response-text {
    font-size: 15px;
    color: #000001;
    flex: 1;
  }

  .response-actions {
    display: flex;
    gap: 4px;
  }

  .action-btn {
    background: transparent;
    border: none;
    color: #6B7280;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;
    padding: 0;

    &:hover {
      background-color: rgba(107, 114, 128, 0.1);
    }
  }
}
</style>